import { useState } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { ClipboardList, FileText } from 'lucide-react'
import DonationReportCard from '../components/DonationReportCard'
import { usePermissions } from '@/utils/permissions'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

export default function Reports() {
  const navigate = useNavigate()
  const permissions = usePermissions()
  const [activeTab, setActiveTab] = useState('donation-report')

  // Redirect users without reports access
  if (!permissions.canAccessReports()) {
    navigate({ to: '/' })
    return null
  }

  return (
    <div className="space-y-6">
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="flex gap-2 w-full">
          <TabsTrigger
            value="donation-report"
            className="flex items-center justify-center gap-2 px-3 py-2 whitespace-nowrap"
          >
            <FileText className="h-4 w-4" />
            Donations
          </TabsTrigger>
          <TabsTrigger
            value="registration-report"
            className="flex items-center justify-center gap-2 px-3 py-2 whitespace-nowrap"
          >
            <ClipboardList className="h-4 w-4" />
            Registrations
          </TabsTrigger>
        </TabsList>
        <TabsContent value="donation-report" className="mt-6">
          <DonationReportCard />
        </TabsContent>
        <TabsContent value="registration-report" className="mt-6">
          <DonationReportCard mode="registrations" />
        </TabsContent>
      </Tabs>
    </div>
  )
}
